import _ from 'lodash'

export const properties = [
  { value: 'PATENT_PENDING', label: 'Patent Pending' },
  { value: 'NATIONAL_PATENTS', label: 'National Patent' },
  { value: 'INTERNATIONAL_PATENTS', label: 'International Patent' },
  { value: 'REGISTERED_TRADEMARK', label: 'Registered Trademark' },
  { value: 'REGISTERED_DESIGN', label: 'Registered Design' },
  { value: 'NONE', label: 'None' },
]

export default function getIntellectualProperty() {
  return properties
}
export const intellectualPropertyChoiceByValue = _.keyBy(properties, 'value')

export function intellectualPropertyLabel(val) {
  const choice = intellectualPropertyChoiceByValue[val]
  if (choice) {
    return choice.label
  }
  return ''
}
